import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type { TypePostSkuImageDeleteResponse } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/sku/image/delete';

/**
 * [상품관리][상품 등록/상세 모달] 상품 이미지 삭제 API
 */
export const fetchPostSkuImageDelete = async (skuImageUrl: string) => {
  const { data } = await axiosInstance.post<TypePostSkuImageDeleteResponse>(ENDPOINT, {
    skuImageUrl,
  });
  return data;
};

/**
 * [상품관리][상품 등록/상세 모달] 상품 이미지 삭제 Mutation Hook
 */
export const usePostSkuImageDeleteMutation = () => {
  return useMutation({
    mutationFn: fetchPostSkuImageDelete,
    meta: { silent: true },
  });
};
